import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CategoryTeaser from '../../components/Shared/CategoryTeaser';
import PermissionsGate from '../../components/PermissionsGate';
import { SCOPES } from '../../helpers/permission-maps';
import './index.scss';

// Each box maps to its own scope so future PRM features can be enabled per user without changing this page.
const prmSections = [
  { label: 'Leads', path: '/prm/leads', description: 'Manage and track new leads.', scope: SCOPES.canAccessPrmLeads },
  {
    label: 'Accounts',
    path: '/prm/accounts',
    description: 'View and manage partner accounts.',
    scope: SCOPES.canAccessPrmAccounts,
  },
  {
    label: 'Contacts',
    path: '/prm/contacts',
    description: 'Browse contacts linked to your accounts.',
    scope: SCOPES.canAccessPrmContacts,
  },
  { label: 'Cases', path: '/prm/cases', description: 'Track and resolve open cases.', scope: SCOPES.canAccessPrmCases },
  {
    label: 'Onboard',
    path: '/prm/onboard',
    description: 'Manage partner onboarding.',
    scope: SCOPES.canAccessPrmOnboard,
  },
  { label: 'Tasks', path: '/prm/tasks', description: 'View tasks assigned to you.', scope: SCOPES.canAccessPrmTasks },
];

const PRM = () => {
  return (
    <div className="prmPage" data-testid="prm-page">
      <Container>
        <Row>
          <Col style={{ marginBottom: 40, marginTop: 40 }}>
            <h1 className="Heading Heading--h5">PRM</h1>
            <p className="Preamble">Access your PRM features below.</p>
          </Col>
        </Row>
        <Row className="gx-4 gy-4">
          {prmSections.map((section) => (
            <PermissionsGate key={section.path} scopes={[section.scope]}>
              <Col xs={12} sm={4} md={4} lg={4}>
                <Link to={section.path}>
                  <CategoryTeaser isFullwidth title={section.label} description={section.description} />
                </Link>
              </Col>
            </PermissionsGate>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default PRM;
